export const GET_DOCUMENT = "GET_DOCUMENT";
